import React, { useRef } from 'react';
import NavbarMain from '../SharedComponents/NavbarNew';
import Hero from '../SharedComponents/Hero';
import HeroNavigation from '../SharedComponents/HeroNavigatoin';
import HeroNavigationMobile from '../SharedComponents/HeroNavigationMobile';
import ExperienceSection from '../SharedComponents/ExperienceSection';
import UserComments from '../SharedComponents/UserComments';
import Footer from '../SharedComponents/Footer';
import PlacesSection from '../SharedComponents/PlaceSection';
import PlansSection from '../SharedComponents/PlansSection';
import PopularDestinations from '../SharedComponents/PopularDestinations ';

const MainPage: React.FC = () => {
  const assistantRef = useRef<HTMLDivElement>(null);

  const scrollToAssistant = () => {
    assistantRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen min-w-screen">
      <NavbarMain />

      <div className="relative">
        <Hero onAdventureClick={scrollToAssistant} />

        {/* Desktop: >= 1440px */}
        <div className="lg:flex hidden relative -mt-14 z-10">
          <HeroNavigation />
        </div>

        {/* Tablet & Mobile: < 1440px */}
        <div className="lg:hidden flex relative mt-[24px] z-10">
          <HeroNavigationMobile />
        </div>
      </div>

      <div className="max-w-8xl mx-auto">

        <div className="pt-6">
          <PopularDestinations />
        </div>

        <PlacesSection title="جاذبه‌های دیدنی" category="جاذبه‌های دیدنی" />
        <PlacesSection title="رستوران‌ها" category="رستوران" />

        <ExperienceSection></ExperienceSection>
        <PlacesSection title="کافه‌ها" category="کافه" />
        <PlacesSection title="اقامتگاه‌ها" category="اقامتگاه" />

        <PlansSection
          title="برنامه‌های سفر"
          viewAllLink="/plans"
        />


        <UserComments />
      </div>

      <Footer />
    </div>
  );
};

export default MainPage;
